import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { IoMdCheckmark } from 'react-icons/io';

import { GuestEntryListItem } from 'legacy/events/types';
import UserImage from 'legacy/user/components/UserImage';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';

interface ManageEntryRowProps {
  entry: GuestEntryListItem;
  onClick: () => void;
  onClickThreeDots: () => void;
}

const ManageEntryRow: React.FC<ManageEntryRowProps> = ({
  entry,
  onClick,
  onClickThreeDots
}) => {
  const { t } = useTranslation(['events']);

  return (
    <div className="flex w-full justify-between px-4 pt-4">
      <div className="flex items-center cursor-pointer" onClick={onClick}>
        <div className="relative mr-4">
          <UserImage
            src={entry?.user?.photoUrl}
            className="rounded-full w-10 h-10"
          />
          {entry?.isScanned && (
            <div className="absolute top-0 left-0 bg-green-800 opacity-75 w-full h-full rounded-full flex items-center justify-center">
              <IoMdCheckmark className="text-white text-2xl" />
            </div>
          )}
        </div>
        <div>
          <div className="text-base font-bold">
            {entry.type === 'complimentary'
              ? entry?.name
              : `${entry?.user?.firstName} ${entry?.user?.lastName}`}
          </div>
          <div className="text-sm  text-gray-500 font-normal">
            {entry?.tier?.name}
          </div>
          <div className="text-sm  text-gray-500 font-normal">
            {entry?.isScanned
              ? t('events:manageEntry.scannedOn', {
                  date: new Date(entry?.scanDate).toLocaleString(
                    i18n.language,
                    {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true
                    }
                  )
                })
              : t('events:manageEntry.notScanned')}
          </div>
        </div>
      </div>

      <div
        className="text-gray-700 text-2xl flex justify-center items-center cursor-pointer"
        onClick={onClickThreeDots}
      >
        <BsThreeDots />
      </div>
    </div>
  );
};

export default ManageEntryRow;
